import React, { useEffect } from 'react';
import { Switch, useHistory } from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import Detail from './Detail';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import PrivateRoute from '~/app/PrivateRoute';
import { useStoreState } from '~/store';
import { ROUTES } from '~/app/Router';

export const TRAINING_ROUTES = {
    details: '/training/:id'
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => {
    const history = useHistory();
    const netWorkStatus = useStoreState(state => state.app.offline.status);

    useEffect(() => {
        if (netWorkStatus !== 0) {
            history.push(ROUTES.projects);
        }
    }, [netWorkStatus, history]);

    if (netWorkStatus !== 0) {
        return null;
    }

    return (
        <RouterSuspense>
            <Switch>
                <PrivateRoute path={TRAINING_ROUTES.details} component={Detail} requiredPermissions={PERMISSION_GROUPS.training} />
            </Switch>
        </RouterSuspense>
    );
};

export default Router;